import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { InternalScrollLink } from '@cc-shopping/ui/composites/InternalScrollLink';
import { SectionTitle } from '@cc-shopping/ui/composites/SectionTitle';
import { LogoBadge as Badge } from '@cc-shopping/ui/primitives/Logo';
import { Box, Typography } from '@mui/material';
import { useRef } from 'react';
import ReviewProductCardRating from 'src/app/credit-cards/reviews/components/Body/Summary/Rating';
import { tableOfContentsMap } from 'src/app/credit-cards/reviews/components/Body/TableOfContents/constants';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { v4 } from 'uuid';
export default function BottomLine() {
  const {
    bottomLine,
    detailedReview
  } = useReviewContext();
  const uuidRef = useRef(v4());
  const fireSelectCardPageAction = usePageAction({
    actionName: 'anchor_link',
    actionSection: '',
    actionType: 'navigate',
    actionInput: '',
    parentActivityId: uuidRef.current
  });
  return <Box mb={{
    xs: 3,
    sm: 4
  }} id={tableOfContentsMap.BOTTOM_LINE.id} width="100%">
      <SectionTitle heading={{
      text: 'The Bottom Line'
    }} icon={{
      IconElement: Badge,
      customCSSStyle: {
        width: '34px',
        height: '34px',
        marginLeft: '5px'
      }
    }} />
      <Box display="flex" flexDirection={{
      xs: 'column',
      sm: 'row'
    }} gap={{
      xs: 3,
      sm: 4
    }}>
        <ReviewProductCardRating />
        <Box display="flex" flexDirection="column">
          {bottomLine && <Box mb={2} data-testid="btmLineTextInfo">
              <StructuredContentRenderer doc={bottomLine} />
            </Box>}
          {detailedReview && <FeatureViewed entityName="anchor_link" entitySection="" impressionPosition={0} activityId={uuidRef.current}>
              <Box display="flex" flexDirection="row">
                <Typography variant="textBold" mr={2}>
                  Jump to:
                </Typography>
                <InternalScrollLink target={tableOfContentsMap.DETAILED_REVIEW.id} onClickAnalyticsCallback={() => {
              fireSelectCardPageAction();
            }}>
                  Detailed Review
                </InternalScrollLink>
              </Box>
            </FeatureViewed>}
        </Box>
      </Box>
    </Box>;
}